<template>
<svg viewBox="0 0 28 29" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-DuoLeiXiangKaCaoXuanZhong`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.0873 6.50678L23.7015 10.7948C24.0425 10.9646 24.2575 11.3135 24.2558 11.6945L24.2177 20.3212C24.2161 20.6799 24.0225 21.0103 23.7103 21.1871L15.0685 26.0789C14.7604 26.2533 14.383 26.2518 14.0763 26.0749L5.63003 21.2045C5.32037 21.0259 5.12957 20.6956 5.12957 20.3382V11.6939C5.12957 11.6007 5.14253 11.5094 5.16715 11.4222L3.77916 7.50845C3.65795 7.16667 3.81783 6.78892 4.14757 6.63799L13.1147 2.53355C13.504 2.35538 13.9606 2.56525 14.0788 2.97671L15.0925 6.50419L15.0873 6.50678ZM13.9237 16.5102L6.64884 12.6718L6.64882 20.0175L13.9237 24.2291V16.5102ZM15.4132 16.5653L22.7392 12.6854V20.0134L15.4133 24.0927L15.4132 16.5653ZM7.57658 11.4745L14.557 7.89246L21.8116 11.4961L14.7211 15.2479L7.57658 11.4745ZM6.26454 9.86997L5.44438 7.69971L5.45245 7.69598L5.4522 7.69532L12.9014 4.25782L12.9015 4.25797L12.9092 4.25439L13.5853 6.68208L13.5967 6.72267L13.5966 6.72273L13.5967 6.72314L6.46 10.3872L6.45798 10.3819L6.45611 10.3828L6.26454 9.86997Z"/></svg>
</template>
<script>

export default {
  name: 'IconDuoLeiXiangKaCaoXuanZhong',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
